import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import AdaptiveAdminLayout from "./mobile/routing/AdaptiveAdminLayout";
import Home from "./components/home/home";
import "./index.css";
import Users from "./components/users/users";
import Login from "./components/login";
import { useEffect } from "react";
import { useContext } from "react";
import AuthContext, { SILENT_REFRESH_INTERVAL_MS } from "./context/authProvider";
import RequireAuth from "./components/utils/requireAuth";
import YouShallNotPass from "./components/utils/youShallNotPass";
import AdaptivePartnerLayout from "./mobile/routing/AdaptivePartnerLayout";
import Products from "./components/products/products";
import MobileProductsList from "./mobile/features/products/MobileProductsList";
import MobileProductDetail from "./mobile/features/products/MobileProductDetail";
import MobileCreateProduct from "./mobile/features/products/MobileCreateProduct";
import MobilePartnerProductsList from "./mobile/features/partner-products/MobilePartnerProductsList";
import MobilePartnerProductDetail from "./mobile/features/partner-products/MobilePartnerProductDetail";
import MobileCreatePartnerProduct from "./mobile/features/partner-products/MobileCreatePartnerProduct";
import MobileHome from "./mobile/features/home/MobileHome";
import MobilePartnerHome from "./mobile/features/home/MobilePartnerHome";
import MobileStatusView from "./mobile/features/status/MobileStatusView";
import MobilePartnerStatusView from "./mobile/features/status/MobilePartnerStatusView";
import MobileUsersList from "./mobile/features/users/MobileUsersList";
import MobileUserDetail from "./mobile/features/users/MobileUserDetail";
import MobileTransactionsList from "./mobile/features/transactions/MobileTransactionsList";
import MobileGradableModelsList from "./mobile/features/gradable-models/MobileGradableModelsList";
import MobileSerialsList from "./mobile/features/serials/MobileSerialsList";
import MobileRegisterSerials from "./mobile/features/serials/MobileRegisterSerials";
import MobileStoresList from "./mobile/features/stores/MobileStoresList";
import MobileHolidaysList from "./mobile/features/holidays/MobileHolidaysList";
import MobileCouponsList from "./mobile/features/coupons/MobileCouponsList";
import MobileLogsList from "./mobile/features/logs/MobileLogsList";
import MobileTagGenerator from "./mobile/features/tags/MobileTagGenerator";
import MobilePresentations from "./mobile/features/presentations/MobilePresentations";
import MobilePresentationViewer from "./mobile/features/presentations/MobilePresentationViewer";
import { withMobileView } from "./mobile/routing/withMobileView";
import Presentations from "./components/presentations/presentations";
import PresentationViewer from "./components/presentations/presentationViewer";
import Transactions from "./components/transactions/transactions";
import Serials from "./components/serials/serials";
import Stores from "./components/stores/stores";
import Holiday from "./components/holidays/holiday";
import LoadingScreen from "./components/utils/loadingScreen";
import PartnerHome from "./components/home/partnerHome";
import PartnerProducts from "./components/products/partner/partnerProducts";
import Logs from "./components/logs/logs";
import GradableModels from "./components/gradableModels/gradableModels";
import Coupons from "./components/coupons/coupons";
import RegisterSerials from "./components/serials/registerSerials/registerSerials";
import User from "./components/users/user/user";
import Product from "./components/products/product/product";
import CreateProduct from "./components/products/createProduct/createProduct";
import StatusView from "./components/statusView";
import TagGenerator from "./components/serials/tags/tagGenerator";
import PartnerProduct from "./components/products/partner/product/partnerProduct";
import CreatePartnerProduct from "./components/products/partner/createProduct/createPartnerProduct";
import PartnerStatusView from "./components/partnerStatusView";
import BotOpsPage from "./components/botOps/botOpsPage";
import ArtLabelsPage from "./components/artLabels/ArtLabelsPage";
import ArtLabelReview from "./components/artLabels/ArtLabelReview";
import ExtendedArtCreate from "./components/extendedArt/ExtendedArtCreate";
import { EXTENDED_ART_KIND } from "./components/extendedArt/kind";

const AdaptiveHome = withMobileView(Home, MobileHome);
const AdaptivePartnerHome = withMobileView(PartnerHome, MobilePartnerHome);
const AdaptiveProducts = withMobileView(Products, MobileProductsList);
const AdaptiveProduct = withMobileView(Product, MobileProductDetail);
const AdaptiveCreateProduct = withMobileView(CreateProduct, MobileCreateProduct);
const AdaptivePartnerProducts = withMobileView(PartnerProducts, MobilePartnerProductsList);
const AdaptivePartnerProduct = withMobileView(PartnerProduct, MobilePartnerProductDetail);
const AdaptiveCreatePartnerProduct = withMobileView(
  CreatePartnerProduct,
  MobileCreatePartnerProduct
);
const AdaptiveStatusView = withMobileView(StatusView, MobileStatusView);
const AdaptivePartnerStatusView = withMobileView(PartnerStatusView, MobilePartnerStatusView);
const AdaptiveUsers = withMobileView(Users, MobileUsersList);
const AdaptiveUser = withMobileView(User, MobileUserDetail);
const AdaptiveTransactions = withMobileView(Transactions, MobileTransactionsList);
const AdaptiveGradableModels = withMobileView(GradableModels, MobileGradableModelsList);
const AdaptiveSerials = withMobileView(Serials, MobileSerialsList);
const AdaptiveRegisterSerials = withMobileView(RegisterSerials, MobileRegisterSerials);
const AdaptiveStores = withMobileView(Stores, MobileStoresList);
const AdaptiveHolidays = withMobileView(Holiday, MobileHolidaysList);
const AdaptiveCoupons = withMobileView(Coupons, MobileCouponsList);
const AdaptiveLogs = withMobileView(Logs, MobileLogsList);
const AdaptiveTagGenerator = withMobileView(TagGenerator, MobileTagGenerator);
const AdaptivePresentations = withMobileView(Presentations, MobilePresentations);
const AdaptivePresentationViewer = withMobileView(
  PresentationViewer,
  MobilePresentationViewer
);

// Trocar de :artKey precisa remontar a revisão — sem a key o estado local
// (variação escolhida, checklist, crop) vazaria de uma arte para a outra.
const KeyedArtLabelReview = (props) => {
  const { artKey } = useParams();
  return <ArtLabelReview key={artKey} {...props} />;
};


function App() {

  const { user, status, bootstrapSession, retrieveRefreshToken } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Sessão durável: access + refresh no localStorage (não depende de cookie HttpOnly).
    bootstrapSession();

    // Renova access em background (TTL 12h). Sem refresh a cada foco de aba.
    const intervalId = setInterval(() => {
      retrieveRefreshToken(undefined, { silent: true });
    }, SILENT_REFRESH_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line
  }, [])

  return (
    
    status === "loading" ? <LoadingScreen/> :
    <Routes>
      <Route path="/" element={<Login user={user} navigate={navigate}/>}/>
      <Route element={<RequireAuth user={user} allowedRoles={["admin"]}/>}>
        <Route path="/manafix" element={<AdaptiveAdminLayout/>}>
          <Route index element={<AdaptiveHome user={user}/>}/>
          <Route path="status" element={<AdaptiveStatusView/>}/>
          <Route path="bot-ops" element={<BotOpsPage/>}/>
          <Route path="users" element={<AdaptiveUsers user={user}/>}/>
          <Route path="users/:id" element={<AdaptiveUser user={user}/>}/>
          <Route path="products" element={<AdaptiveProducts user={user}/>}/>
          <Route path="products/create" element={<AdaptiveCreateProduct user={user}/>}/>
          <Route path="products/:id" element={<AdaptiveProduct user={user}/>}/>
          <Route path="transactions" element={<AdaptiveTransactions user={user}/>}/>
          <Route path="gradable-models" element={<AdaptiveGradableModels user={user}/>}/>
          <Route path="serials" element={<AdaptiveSerials user={user}/>}/>
          <Route path="serials/register" element={<AdaptiveRegisterSerials user={user}/>}/>
          <Route path="serials/tags" element={<AdaptiveTagGenerator user={user}/>}/>
          <Route path="art-labels" element={<ArtLabelsPage user={user}/>}/>
          <Route path="art-labels/:artKey" element={<KeyedArtLabelReview user={user}/>}/>
          <Route path="extended-art/create" element={<ExtendedArtCreate user={user}/>}/>
          <Route path="extended-art/:id" element={<Product user={user} kind={EXTENDED_ART_KIND}/>}/>
          <Route path="stores" element={<AdaptiveStores user={user}/>}/>
          <Route path="feriados" element={<AdaptiveHolidays user={user}/>}/>
          <Route path="coupons" element={<AdaptiveCoupons user={user}/>}/>
          <Route element={<RequireAuth user={user} allowedRoles={["master"]}/>}>
            <Route path="logs" element={<AdaptiveLogs user={user}/>}/>
            <Route path="presentations" element={<AdaptivePresentations user={user}/>}/>
            <Route path="presentations/:id" element={<AdaptivePresentationViewer user={user}/>}/>
          </Route>
        </Route>
      </Route>
      <Route element={<RequireAuth user={user} allowedRoles={["partner"]}/>}>
        <Route path="/partner" element={<AdaptivePartnerLayout/>}>
          <Route index element={<AdaptivePartnerHome user={user}/>}/>
          <Route path="products" element={<AdaptivePartnerProducts user={user}/>}/>
          <Route path="products/create" element={<AdaptiveCreatePartnerProduct user={user}/>}/>
          <Route path="products/:id" element={<AdaptivePartnerProduct user={user}/>}/>
          <Route path="status" element={<AdaptivePartnerStatusView/>}/>
        </Route>
      </Route>
      <Route path="youshallnotpass" element={<YouShallNotPass navigate={navigate}/>}/>
   </Routes>  
      
  );
}

export default App;
